module.exports = __webpack_public_path__ + "img/ban_9.e8794e78.png";